import { render } from "./FaceNeutral.vue?vue&type=template&id=d9feffe8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/FaceNeutral.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9feffe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9feffe8', __exports__)) {
    api.reload('d9feffe8', __exports__)
  }
  
  module.hot.accept("./FaceNeutral.vue?vue&type=template&id=d9feffe8", () => {
    api.rerender('d9feffe8', render)
  })

}


export default __exports__